import { Request } from './Request';

export interface IUpdateGroupNameParams {
  groupId: string;
  name: string;
}

export interface IUpdateGroupNameResult {
}

export class UpdateGroupNameRequest extends Request<IUpdateGroupNameParams, IUpdateGroupNameResult> {
  constructor(params: IUpdateGroupNameParams) {
    super('updateGroupName', params);
  }
}
